import { RecaptchaInput } from '#/components/RecaptchaInput/RecaptchaInput';
import { configValue } from '#/config/appConfigUtils';
import { useI18n } from '#/i18n/hooks/useI18n';

import { CheckboxField } from './CheckboxField';
import { Field } from './Field/Field';

export function RecaptchaField() {
  const { locale } = useI18n();

  return configValue('google', 'recaptcha', 'enabled') ? (
    <Field
      name="gRecaptchaResponse"
      renderInput={({ values, updateValue }) => (
        <RecaptchaInput
          key={values.recaptchaKey}
          onChange={(gRecaptchaResponse) => {
            updateValue(gRecaptchaResponse);
          }}
          locale={locale}
        />
      )}
    />
  ) : (
    <CheckboxField
      name="gRecaptchaResponse"
      label="I'm not a robot"
      valueToChecked={{ recaptcha_mock: true, nope: false }}
    />
  );
}
